export const environment = {
  production: true,
  environmentName: 'uat',
  apiUrl: "/portalApi",
  steamApiUrl: "/steamApi",
  paymentApiUrl: "/paymentapi",
  pockytApiUrl: "/pockytapi",
  cccApiUrl: "/cccapi",
  achApiUrl: "/achapi",
  invoiceApiUrl: "/invoiceapi",
  secretKey: "1995",
  isSwitchTPN: true,
  usePosParamCacheApi: true,
  apiFullUrl: "https://api.ipospays.tech/v1",
  portalUrl: "https://www.ipospays.tech",  
  steamApiFullUrl: "https://steam.ipospays.tech/v1",
  portalImagePath: "assets/images",
  portalMerchantLogoPath: "https://ipospays.tech/portalApi/assets/images/merchantlogos",
  steamImagePath:"../../../data/steam/assets/images",
  dateFormat: "MM-DD-yyyy",
  dateTimeFormat: "MM-DD-yyyy - HH:mm:ss",
  displayTimeZone: 'America/New_York',
  autoLogoutTime: 240,
  checkInterval: 1000,
  inspect: true,
  minorChannel : {
    0: "POS Terminal",
    1: "SPIN-LOCAL",
    2: "SPIN-CLOUD",
    3: "PINPAD",
    4: "E-Commerce",
    5: "RECURRING-PAYMENT",
    6: "INVOICE-PAYMENT",
    7: "CUSTOMER-PAYMENT",
    8: "Tap on phone",
    9: "EXTERNAL-ECOM",
    10: "ACH",
    11: "GHPP",
    12: "POS-CUSTOMER-PAYMENT",
    13: "CP-PINPAD",
    14: "Google Pay",
    15: "External E-Commerce-FTD",
    16: "Econduit",
    17: "WooCommerce-Redirect",
    18 : "Apple Pay",
    19: "WooCommerce-Embedded",
    20: "Deep Linking iOS",
    21: "In-App SDK iOS",
    22 : "WooCommerce",
    23 : "WooCommerce Embedded Google pay",
    24 : "Paypal",
    25 : "Venmo",
    26 : "Crypto",
    27 : "USB",
    28 : "SPIN-USB"
        // If adding new value for minor channel, Need to add values in Portal API --> utils --> minor Channel object

  },
  POSMode: {
    "100": "COF",
    "110": "CONTACTLESS",
    "112": "CONTACTLESS",
    "710": "CONTACTLESS",
    "711": "CONTACTLESS",
    "712": "CONTACTLESS",
    "800": "SWIPE",
    "801": "SWIPE",
    "802": "SWIPE",
    "900": "SWIPE",
    "901": "SWIPE",
    "902": "SWIPE",
    "071": "CONTACTLESS",
    "010": "MANUAL",
    "011": "MANUAL",
    "012": "MANUAL",
    "050": "CHIP",
    "051": "CHIP",
    "052": "CHIP",
    "004": "CHECK"
  },
  qbDesc: {
    "1": "Development Settings",
    "2": false,
    "3": false

  },
  spinServer:'https://test.spinpos.net/',
  pagoServer:'https://ipos-gateway.test.pago.dev/',
  enableClientError:false,
  keySize : 256,
  ivSize : 128,
  iterations : 100,
  defaultLogo:'https://www.ipospays.tech/portalApi/assets/images/defaultLogo/iPOSpays.png',
  CAPTCHA_SITE_KEY:'6LfqJcEpAAAAANOZJIqfJppkD8riVWygYA_pZSzn',
  version: "4",
  whitelabelLogoPath: "https://ipospays.tech/portalApi/assets/images/whitelabelImages",
  defaultPaymentDomain:"https://payment.ipospays.tech",
  defaultIcon:"https://ipospays.tech/assets/images/iPOS.png",
  defaultPaymentTabName:"IPOSpays Payment Form",
  apiDocsLink:"https://docs.ipospays.com/",
  knowledgeBaseLink:"https://knowledge.ipospays.com/",
  releaseNotesLink:"https://releases.ipospays.com/",
  payaEntryClasses:{
    'PPD':'PERSONAL',
    'CCD':'BUSINESS'
  },
  brandingUrl :"https://pay.ipospays.tech/branding",
  paymentGatwayApi:"https://pay.ipospays.tech",
  chatAPi:"/chatApi",
  vipUrl: "https://dejaup.ipospays.tech",
  enableDemoCredentials: true,
  VERICHECKACH: {
    client_id: 'bb6da5b6-81bc-4b59-8f75-9ce3c9dec073',
    client_secret: 'wyG8Q~4wkTaInjO0YB6sPK4MNGpxAT6J4eJ.Ddnj'
  },
  ACH: {
    clientId: '9900023058'
  },
  PAYAACH: {
    webTerminalId: '2310',
    telTerminalId: '1210',
    ppdTerminalId: '1010',
    ccdTerminalId: '1710'
  },

  SUBMIT_WINDOW_MS: 10 * 60 * 1000,
  
};
